import { Map } from "immutable";
import { SCORECARD_ACTIONS } from "constants/actions";
import { STATE_STATUS, INITIATE_CASE_STATE } from "constants";
import { ScoreCardRecord } from "records";
import { ScoreCardRecordPipeline } from "utilities/data-pipelines";

const INITIAL_STATE = new Map({});

const DEFAULT_SCORECARD_STATE = new Map({
    status: STATE_STATUS.UNFETCHED,
    data: new ScoreCardRecord()
});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
    case INITIATE_CASE_STATE:
        return state.set(payload.case_id, DEFAULT_SCORECARD_STATE);
    case SCORECARD_ACTIONS.FETCH_SCORECARD:
        return state.setIn(
            [payload.case_id, payload.scorecard_type, "status"],
            STATE_STATUS.FETCHING
        );
    case SCORECARD_ACTIONS.FETCHED_SCORECARD:
        return state
            .setIn(
                [payload.case_id, payload.scorecard_type, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                [payload.case_id, payload.scorecard_type, "data"],
                ScoreCardRecordPipeline.run({
                    id: payload.scorecard_type,
                    ...payload.scorecard.scorecard
                })
            );
    case SCORECARD_ACTIONS.FAILED_FETCH_SCORECARD:
        return state
            .setIn([payload.case_id, "status"], STATE_STATUS.FETCH_FAILED)
            .setIn([payload.case_id, "error"], error);
    case SCORECARD_ACTIONS.GENERATE_SCORECARD:
        return state.setIn(
            [payload.case_id, "status"],
            STATE_STATUS.CREATING
        );
    case SCORECARD_ACTIONS.GENERATED_SCORECARD:
        return state.setIn(
            [payload.case_id, "status"],
            STATE_STATUS.CREATED
        );
    case SCORECARD_ACTIONS.FAILED_GENERATE_SCORECARD:
        return state
            .setIn([payload.case_id, "status"], STATE_STATUS.CREATE_FAILED)
            .setIn([payload.case_id, "error"], error);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
